<template>
  <div class="has-text-right">
    <a href="javascript:;" @click="$root.$emit('filters_reset')" class="btn-filter-reset">{{$t('filter_reset')}} <i class="fas fa-redo"></i></a>

  <div id="filter-block">
    <div class="columns" >
      <div class="column has-text-centered" :class="{'is-one-half':filtersList.length===2,'is-one-third':filtersList.length===3,'is-one-quarter':filtersList.length===4,'border-left':index>0}" v-for="(filter,index) in filtersList" :key="filter.code">
        <filter-item :filter="filter" :index="index" :filters="filtersList" />
      </div>
    </div>

  </div>
  </div>
</template>

<script>
import FilterItem from "@/components/ResearchBlock/machines/FilterItem";

import {mapState} from "vuex";
export default {
name: "FiltersList",
  components : {
  FilterItem
  },
  computed: {
      ...mapState({
        selectedCategory: state => state.searchMachines.category,
        filtersList: state => state.searchMachines.filtersList
      }),
  }


}
</script>

<style lang="scss" scoped>
  #filter-block {
    margin-top:15px;
    border-radius:50px;
    background-color: $brand-red;
    padding:30px;

    .border-left {
      border-left:solid 1px rgba(255,255,255,0.3);
    }
  }

  .btn-filter-reset {
    background-color: $light-grey;
    border-radius:30px;
    padding:5px 20px;


    i {
      margin-left:20px;
      color:$brand-red;
    }
  }
</style>